<template>
  <div id="application_ready_outer" v-if="applicationData != null">

    <div style="text-align:center; color: #fc1a34;margin-bottom: 15px;" v-if="errorMsg != null">
      <span>{{errorMsg}}</span>
    </div>

    <div class="input-row" >
      <div class="column">*团体类型：</div>
      <div class="column">
        <el-select  placeholder="请选择团体类型" v-model="teamTypeValue" @change="teamTypeValueChanged">
          <el-option
            v-for="(item, index) in teamTypeList"
            :key="'type_select_' + index"
            :label="item"
            :value="item"
          />
        </el-select>
        <el-input v-if="teamTypeValue == '其他'"
          v-model="applicationData.teamType"
          style="margin-top: 15px;"
          @change="valueChanged"
          placeholder="请输入团体类型" />
      </div>
    </div>

    <div class="input-row">
      <div class="column">*单位名称：</div>
      <div class="column">
        <el-input v-model="applicationData.name" placeholder="请输入单位全称" @change="valueChanged"/>
      </div>
    </div>

    <div class="input-row">
      <div class="column">*统一社会信用代码：</div>
      <div class="column">
        <el-input v-model="applicationData.idNumber" placeholder="请输入统一社会信用代码" @change="valueChanged"/>
      </div>
    </div>

    <div class="input-row">
      <div class="column">*注册时间：</div>
      <div class="column">
        <!-- <el-input v-model="applicationData.foundedDate" @change="valueChanged"/> -->
        <el-date-picker
            clearable
            v-model="applicationData.foundedDate"
            align="right"
            type="date"
            format="yyyy/MM/dd"
            placeholder="选择日期"
            @change="valueChanged"
          />
      </div>
    </div>

    <div class="input-row">
      <div class="column">*单位注册地址：</div>
      <div class="column">
        <el-input v-model="applicationData.nativePlace" @change="valueChanged"/>
      </div>
    </div>

    <div class="input-row">
      <div class="column">*单位办公地址：</div>
      <div class="column">
        <el-input v-model="applicationData.addr" @change="valueChanged"/>
      </div>
    </div>

    <div class="input-row">
      <div class="column">*法定代表人：</div>
      <div class="column">
        <el-input v-model="applicationData.legalPerson" @change="valueChanged" />
      </div>
    </div>

    <div class="input-row">
      <div class="column">*会员代表：</div>
      <div class="column">
        <el-input v-model="applicationData.memberPerson"
            placeholder="企业填单位董事长或总经理，学校及社会组织填单位负责人"
            @change="valueChanged"
        />
      </div>
    </div>

    <div class="input-row">
      <div class="column">*联系电话：</div>
      <div class="column">
        <el-input v-model="applicationData.mobile" @change="valueChanged" />
      </div>
    </div>

    <div class="input-row">
      <div class="column">*联系邮箱：</div>
      <div class="column">
        <el-input v-model="applicationData.email" @change="valueChanged" />
      </div>
    </div>

    <div class="input-row">
      <div class="column">*单位情况简介：</div>
      <div class="column">
        <el-input v-model="applicationData.desc"
                    type="textarea"
                    :autosize="{minRows: 5, maxRows: 15}"
                    placeholder="简要写明单位开展的与体育行业相关的业务或对体育行业发展的贡献"
                    @change="valueChanged" />
      </div>
    </div>

    <div class="input-row">
      <div class="column">*上传团体证件：</div>
      <div class="column">
        <el-upload
          id="official_cards_upload"
          action="https://api.shslqxh.com/upload/files"
          :headers="headers"
          name="files"
          :file-list="initialFileList"
          multiple
          accept=".jpg, .jpeg, .png, .bmp, .pdf, .JPG, .JPEG"
          list-type="picture-card"
          :on-remove="handlePictureRemove"
          :on-success="handlePictureUploadSuccess"
          :on-preview="handlePicturePreview">
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">请上传企业资质有效文件，如营业执照、机构代码证、税务登记证、经营许可证。需复印盖章后，拍照上传。</div>
        </el-upload>
      </div>
    </div>

    <div class="input-row">
      <div class="column">*会员实体铜牌：</div>
      <div class="column">
        <el-radio v-model="applicationData.medal" :label="1" >需要(+500¥)</el-radio>
        <el-radio v-model="applicationData.medal" :label="2">不需要</el-radio>
      </div>
    </div>


    <div class="input-row">
      <div class="column">*联系人姓名：</div>
      <div class="column">
        <el-input v-model="applicationData.contacts" placeholder="请输入联系人姓名" @change="valueChanged" />
      </div>
    </div>

    <div class="input-row">
      <div class="column">*联系人电话：</div>
      <div class="column">
        <el-input v-model="applicationData.tel" placeholder="请输入联系人手机号" >
          <template slot="append">
            <el-button v-if="codeTimeValue == 0" class="input-right-button-able" @click="codeButtonClicked">获取验证码</el-button>
            <el-button v-else class="input-right-button-disable" disabled>{{codeTimeValue}}s重新获取</el-button>
          </template>
        </el-input>
      </div>
    </div>

    <div class="input-row">
      <div class="column">*短信验证码：</div>
      <div class="column">
        <el-input v-model="applicationData.verificationCode" placeholder="请输入短信验证码" />
      </div>
    </div>


    <div class="input-row">
      <div class="column">*申请函：</div>
      <div id="application_letter" class="column">
        <div>以上信息确认无误后，可点击<a href="javascript:void(0)" style="text-decoration: none;" @click="downloadApplicationLetter">下载申请函文件</a>，盖章签字后上传。</div>
        <el-upload  id="application_cards_upload"
                    class="upload-files"
                    action="https://api.shslqxh.com/upload/files"
                    :headers="headers"
                    name="files"
                    :file-list="appcationLetterInitialList"
                    :limit="1"
                    :on-exceed="handleExceed"
                    list-type="text"
                    accept=".jpg, .jpeg, .png, .bmp, .pdf, .JPG, .JPEG, .PDF, .xls, .docx, .xlsx"
                    :on-remove="handleApplicationCardRemove"
                    :on-success="handleApplicationCardUploadSuccess"
                     >

          <el-button size="small" type="primary" round style="max-width: 200px;">上传扫描件</el-button>

        </el-upload>
      </div>
    </div>
<!--
    <div style="width: 100%;margin-top: 30px;">
      <el-checkbox class="bottom-notice-check" v-model="applicationData.isChecked" >我承诺上述材料准确无误，如有虚假信息，一切后果由本人承担</el-checkbox>
    </div>
  -->
    <div class="input-row" style="margin-top: 30px;">
      <div class="column"></div>
      <div class="column" >
        <!-- <el-button
          style="color: #666;width: 120px;background-color: white;"
          @click="cancelButtonClicked"
          round>取消</el-button> -->
        <el-button
          style="background-color: #fc1a34;border-color: #fc1a34;width: 50%;margin-left: 30px;max-width: 200px;"
          type="primary"
          @click="submitButtonClicked"
          round>下一步</el-button>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageurl" alt="" />
    </el-dialog>

    <application-letter v-if="isApplicationLetterShowed" v-bind:user="tempUser" v-on:close="letterPreviewClosed" />

    <remote-script src="https://img.shslqxh.com/simsun-normal.js" v-on:load="loadNormalFontSuccess" v-on:error="loadNormalFontError"></remote-script>
    <remote-script src="https://img.shslqxh.com/sun-bold.js" v-on:load="loadBoldFontSuccess" v-on:error="loadBoldFontError"></remote-script>

  </div>
</template>

<script>

  import EventManager from "../../../js/event-common";
  import GroupApplicationLetter from "./GroupApplicationLetter";
  import TestView from "./TestView";
  import pdfManager from "../../../js/pdf-manager.js";
  import { Loading } from 'element-ui';
  export default {
    name: "GroupApplicationReady",
    components: {
      ApplicationLetter: GroupApplicationLetter,
    },
    data() {
      return {
        memberType: -1,
        memberText: '',
        memberAdditionText: '',
        headers: {},
        codeTimeValue: 0,
        codeTimerFlag: null,
        errorMsg: null,
        teamTypeList: [
          '区篮协',
          '企业',
          '学校',
          '社会团体',
          '其他'
        ],

        initialData: {
          teamType: '', // 团体类型名称
          name: '', // 单位名称,
          idNumber: '', // 统一社会信用代码
          foundedDate: '', // 注册时间
          nativePlace: '', // 单位注册地址
          addr: '', // 单位办公地址
          legalPerson: '', // 法定代表人
          memberPerson: '', // 会员代表
          mobile: '', // 联系电话
          email: '', // 联系邮箱,
          desc: '', // 单位情况简介
          license: '', //团体证件/营业执照
          medal: 0, // 是否需要会员铜牌， 1 需要； 2 不需要
          contacts: '', // 联系人姓名
          tel: '', // 联系人电话
          verificationCode: '', // 短信验证码
          applicationLetter: '', // 申请函
        },

        teamTypeValue: null,
        applicationData: null,
        fileList: [],
        initialFileList: [],
        dialogVisible: false,
        dialogImageurl: null,
        isApplicationLetterShowed: false,
        tempUser: null,
        appcationLetterInitialList: [],
      }
    },
    computed: {
      httpManager() {
        return this.$store.state.http;
      },
      user() {
        return this.$store.state.user;
      },
    },
    destroyed() {
      this.closeCodeTime();
    },
    mounted() {
      let token = this.$store.state.dataStore.getToken();
      this.headers.token = token;
      this.initApplicationData();
    },
    methods: {
      loadNormalFontSuccess(event) {
        pdfManager.loadNormalFontSuccess(event);
      },

      loadNormalFontError(event) {
        pdf.loadNormalFontError(event);
      },

      loadBoldFontSuccess(event) {
        pdfManager.loadBoldFontSuccess(event);
      },

      loadBoldFontError(event) {
        pdfManager.loadBoldFontError(event);
      },

      letterPreviewClosed() {
        this.isApplicationLetterShowed = false;
        this.tempUser = null;
      },

      downloadApplicationLetter() {
        let params = {};

        let teamTypeValue = this.teamTypeValue;
        if (this.teamTypeValue == null) {
          this.$toast('请选择团体类型！');
          return;
        }

        let teamType = this.applicationData.teamType.removeBlanks();
        if (teamTypeValue != '其他') {
          teamType = teamTypeValue;
        } else {
          if (teamType == '') {
            this.$toast('请输入团体类型！');
            return;
          }
        }
        params.teamType = teamType;

        let name = this.applicationData.name.removeBlanks();
        if (name == '') {
          this.$toast('请输入单位名称！');
          return;
        }
        params.name = name;

        let idNumber = this.applicationData.idNumber.removeBlanks();
        if (idNumber == '') {
          this.$toast('请输入统一社会信用代码！');
          return;
        }
        params.idNumber = idNumber;

        let foundedDate = this.applicationData.foundedDate;
        if (foundedDate == '' || foundedDate == null) {
          this.$toast('请选择注册时间！');
          return;
        }

        params.foundedDate = foundedDate;

        let nativePlace = this.applicationData.nativePlace.removeNamesBlank();
        if (nativePlace == '') {
          this.$toast('请输入单位注册地址！');
          return;
        }
        params.nativePlace = nativePlace;

        let addr = this.applicationData.addr.removeNamesBlank();
        if (addr == '') {
          this.$toast('请输入单位办公地址！');
          return;
        }
        params.addr = addr;

        let legalPerson = this.applicationData.legalPerson.removeNamesBlank();
        if (legalPerson == '') {
          this.$toast('请输入法定代表人！');
          return;
        }
        params.legalPerson = legalPerson;

        let memberPerson = this.applicationData.memberPerson.removeNamesBlank();
        if (memberPerson == '') {
          this.$toast('请输入会员代表！');
          return;
        }
        params.memberPerson = memberPerson;

        let mobile = this.applicationData.mobile.removeBlanks();
        if (mobile == '') {
          this.$toast('请输入团体联系电话！');
          return;
        }
        params.mobile = mobile;

        let email = this.applicationData.email.removeBlanks();
        if (email == '') {
          this.$toast('请输入团体联系邮箱！');
          return;
        }
        params.email = email;

        let desc = this.applicationData.desc.removeNamesBlank();
        if (desc == '') {
          this.$toast('请输入单位详情简介！');
          return;
        }
        params.desc = desc;

        let license = this.applicationData.license;
        if (license == '') {
          this.$toast('请上传团体证件！');
          return;
        }
        params.license = license;

        //contacts
        let contacts = this.applicationData.contacts.removeNamesBlank();
        if (contacts == '') {
          this.$toast('请输入联系人姓名！');
          return;
        }
        params.contacts = contacts;

        let tel = this.applicationData.tel.removeBlanks();
        if (tel == '') {
          this.$toast('请输入联系人电话！');
          return;
        }

        if (!tel.isPhoneNumber()) {
          this.$toast('手机格式不正确！');
          return;
        }
        params.tel = tel;

        let loadFlags = Loading.service({
          target: document.getElementById('app'),
          fullscreen: true,
          text: "拼命下载中...",
        });
        let user = this.generateNewUser(params);
        let _this = this;
        pdfManager.convertToPdf({
          user,
          fileName: '上海市篮球协会团体会员入会申请书.pdf'
        }, function() {
          loadFlags.close();
        }, function(code) {
          if (code == 1) { // 子集加载错误
            _this.$toast('依赖加载异常，请刷新页面，重新操作！');
          }
        });
      },

      teamTypeValueChanged() {
        // let teamTypeValue = this.teamTypeValue;
        // if (teamTypeValue != '其他') {
        //   this.applicationData.teamType = teamTypeValue;
        // } else {
        //   this.teamTypeValue =
        // }
        // this.valueChanged();
      },

      valueChanged() {
      let isEdit = false;
      for (let key in this.initialData) {
        let initialValue = this.initialData[key];
        let value = initialValue;

        if (key == 'name' || key == 'experience') {
          let value = this.applicationData[key].removeNamesBlank();
        } else {
          value = this.applicationData[key];
          if (typeof value == 'string') {
            value = value.removeBlanks();
          }
        }
        if (value != initialValue) {
          isEdit = true;
          break
        }
      }
      let storedEditing = !this.$store.state.allowedLeave;
      this.isEdited = isEdit;
      if (storedEditing != isEdit) {
        this.$store.commit('isAllowedLeave', !isEdit);
      }
    },

    initFileList(license) {
      if (license == null || license == '') {
        return;
      }
      let tmpArray = license.split(',');
      for (let i = 0; i < tmpArray.length; i++) {
        let imageUrl = tmpArray[i];
        if (imageUrl.length > 0) {
          let item = {
            name: 'image_' + i,
            url: imageUrl
          };
          this.fileList.push(item);
          this.initialFileList.push(item);
        }
      }
    },


      configErrorMsg() {
        let idErrorRemark = this.$store.state.idErrorRemark;
        if (idErrorRemark != null) {
          this.errorMsg = idErrorRemark;
          this.$store.commit('setIdErrorRemark', null);
        } else {
          let user = this.user;
          let auditRemark = user.auditRemark;
          let status = user.status;
          if (status == 4 && auditRemark != null && auditRemark != '') {
            this.errorMsg = auditRemark;
          }
        }
      },

      initApplicationData() {
        let user = this.user;
        if (user == null) {
          let _this = this;
          setTimeout(function () {
            _this.initApplicationData();
          },50);
          return;
        }

        console.log(user);
        let applicationData = {};
        for (let key in this.initialData) {
          let value = user[key];
          if (value == undefined || value == null) {
            value = this.initialData[key];
          }

          this.initialData[key] = value;
          applicationData[key] = value;
        }
        if (applicationData.teamType == null || applicationData.teamType == '') {
          this.teamTypeValue =  '';
          applicationData.teamType = '';
          this.initialData.teamType = '';

        } else {
          if (this.teamTypeList.indexOf(applicationData.teamType) >= 0) {
            this.teamTypeValue = applicationData.teamType;
          } else {
            this.teamTypeValue = '其他';
          }
        }


        if (applicationData.applicationLetter != null && applicationData.applicationLetter.length > 0) {
          this.appcationLetterInitialList.push({
            name: '上海市篮球协会团体会员入会申请书.pdf',
            url: applicationData.applicationLetter
          });
        }

        this.applicationData = applicationData;
        this.initFileList(this.applicationData.license);
        this.configErrorMsg();
      },

      cancelButtonClicked() {
        EventManager.postNotification(EventManager.notificationNameObject.VipApplyCancel);
      },

      codeButtonClicked() {
        if (this.codeTimeValue > 0) {
          return;
        }

        let phoneNumbers = this.applicationData.tel.removeBlanks();
        if (phoneNumbers == '') {
          this.$toast('请输入联系人电话！');
          return;
        }

        if (!phoneNumbers.isPhoneNumber()) {
          this.$toast('手机号格式不正确！');
          return;
        }
        let params = {
          tag: 'member',
          phoneNumbers
        };
        let _this = this;
        this.httpManager.ajax.smsSend(params, function (data) {
          if (data.code == 0) {
            _this.beginCodeTime();
          }
        }, function (data) {
          _this.$toast('请求失败，请重试！');

        });
      },

      beginCodeTime() {
        this.codeTimeValue = 60;

        let _this = this;
        this.codeTimerFlag = setInterval(function () {
          _this.codeTimeValue --;
          if (_this.codeTimeValue <= 0) {
            _this.closeCodeTime();
          }
        }, 1000);
      },
      closeCodeTime() {
        if (this.codeTimerFlag != null) {
          clearInterval(this.codeTimerFlag);
          this.codeTimerFlag = null;
        }
      },

      updateUserLicense() {
        let fileList = this.fileList;
        let tmp = '';
        if (fileList.length > 0) {
          for (let i = 0; i < fileList.length; i++) {
            let image = fileList[i];
            tmp += image.url;
            if (i < fileList.length - 1) {
              tmp += ',';
            }
          }
        }
        this.applicationData.license = tmp;
      },

      handlePicturePreview(file) {
        let url = file.response;
        if (url == undefined || url == null) {
          url = file.url;
        }
        console.log(file);
        this.dialogImageurl = url;
        this.dialogVisible = true;
      },

      handlePictureUploadSuccess(res, file) {
        console.log(file);
        console.log(res);
        if (typeof res == 'string') {
          let name = file.name;
          let url = res;
          let obj = {
            name,
            url
          };
          this.fileList.push(obj);
          this.updateUserLicense();
          this.valueChanged();
        }
      },
      handlePictureRemove(file, fileList) {
        let url = file.response;
        let index = this.fileList.findIndex(function (item) {
          return item.url == url;
        });
        this.fileList.splice(index, 1);
        this.updateUserLicense();
        this.valueChanged();
      },

      handleApplicationCardUploadSuccess(res, file) {
        if (typeof  res == 'string') {
          this.applicationData.applicationLetter = res;
          this.valueChanged();
          // this.applicationData.applicationCardList.push(res);
        }
      },

      handleApplicationCardRemove(file, fileList) {
        this.applicationData.applicationLetter = '';
        this.valueChanged();
      },
      handleExceed(file, fileList) {
        this.$message.warning('申请函只能上传一份，如需更换，请先删除已选，再重新上传！');
      },

      generateNewUser(params) {
        let user = this.user;
        for (let key in params) {
          let value = params[key];
          user[key] = value;
        }
        return user;
      },

      submitButtonClicked() {
        let params = {};

        let teamTypeValue = this.teamTypeValue;
        if (this.teamTypeValue == null) {
          this.$toast('请选择团体类型！');
          return;
        }

        let teamType = this.applicationData.teamType.removeBlanks();
        if (teamTypeValue != '其他') {
          teamType = teamTypeValue;
        } else {
          if (teamType == '') {
            this.$toast('请输入团体类型！');
            return;
          }
        }
        params.teamType = teamType;

        let name = this.applicationData.name.removeBlanks();
        if (name == '') {
          this.$toast('请输入单位名称！');
          return;
        }
        params.name = name;

        let idNumber = this.applicationData.idNumber.removeBlanks();
        if (idNumber == '') {
          this.$toast('请输入统一社会信用代码！');
          return;
        }
        params.idNumber = idNumber;

        let foundedDate = this.applicationData.foundedDate;
        if (foundedDate == '' || foundedDate == null) {
          this.$toast('请选择注册时间！');
          return;
        }
        let dateStr = this.$moment(foundedDate).format('yyyy-MM-DD')
        params.sFoundedDate = dateStr;

        let nativePlace = this.applicationData.nativePlace.removeNamesBlank();
        if (nativePlace == '') {
          this.$toast('请输入单位注册地址！');
          return;
        }
        params.nativePlace = nativePlace;

        let addr = this.applicationData.addr.removeNamesBlank();
        if (addr == '') {
          this.$toast('请输入单位办公地址！');
          return;
        }
        params.addr = addr;

        let legalPerson = this.applicationData.legalPerson.removeNamesBlank();
        if (legalPerson == '') {
          this.$toast('请输入法定代表人！');
          return;
        }
        params.legalPerson = legalPerson;

        let memberPerson = this.applicationData.memberPerson.removeNamesBlank();
        if (memberPerson == '') {
          this.$toast('请输入会员代表！');
          return;
        }
        params.memberPerson = memberPerson;

        let mobile = this.applicationData.mobile.removeBlanks();
        if (mobile == '') {
          this.$toast('请输入团体联系电话！');
          return;
        }
        params.mobile = mobile;

        let email = this.applicationData.email.removeBlanks();
        if (email == '') {
          this.$toast('请输入团体联系邮箱！');
          return;
        }
        params.email = email;

        let desc = this.applicationData.desc.removeNamesBlank();
        if (desc == '') {
          this.$toast('请输入单位详情简介！');
          return;
        }
        params.desc = desc;

        let license = this.applicationData.license;
        if (license == '') {
          this.$toast('请上传团体证件！');
          return;
        }
        params.license = license;

        let medal = this.applicationData.medal;
        if (medal != 1 && medal != 2) {
          this.$toast('请选择是否需要实体铜牌！');
          return;
        }
        params.medal = medal;

        //contacts
        let contacts = this.applicationData.contacts.removeNamesBlank();
        if (contacts == '') {
          this.$toast('请输入联系人姓名！');
          return;
        }
        params.contacts = contacts;

        let tel = this.applicationData.tel.removeBlanks();
        if (tel == '') {
          this.$toast('请输入联系人电话！');
          return;
        }

        if (!tel.isPhoneNumber()) {
          this.$toast('手机格式不正确！');
          return;
        }
        params.tel = tel;

        let verificationCode = this.applicationData.verificationCode.removeBlanks();
        if (verificationCode == '') {
          this.$toast('请输入短信验证码！');
          return;
        }
        params.verificationCode = verificationCode;

        let applicationLetter = this.applicationData.applicationLetter;
        if (applicationLetter == '') {
          this.$toast('请上传申请函！');
          return;
        }
        params.applicationLetter = applicationLetter;
        params.flag = 6;
        this.postUserInforUpdateRequest(params);
      },

      postUserInforUpdateRequest(params) {
      let user = this.user;
      let modified = user.modified;
      if (modified == 0 || modified == null) {
        modified = this.isEdited ? 1 : 0;
      }

      let memberValidDate = user.memberValidDate;
      let auditStatus = user.auditStatus;
      let status = this.user.status;

      if (memberValidDate == null) { // 不是会员
          status = 1; // 到协会审核
        } else { // 会员已过期
          if (modified > 0) { // 数据已修改，到协会审核
            status = 1;
          } else { // 数据未修改, 到支付页面
            status = 2;
          }
        }

      params.status = status;
      params.modified = modified;
      params.auditStatus = 1;

      let _this = this;
      console.log(params);
      // return;
      this.httpManager.ajax.ucProfileUpdate(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.$toast('提交成功！');
          // user.status = 1;
          // _this.$store.commit('setUser', user);
          _this.$emit('submitSuccess');
          _this.$store.commit("isAllowedLeave", true);
          return;
        }
        _this.$toast('提交失败！');

      }, function (data) {
        _this.$toast('提交失败，请重试！');
      });
    },



    }
  }
</script>

<style scoped>
  #application_ready_outer {
    padding: 15px 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #application_ready_outer > div {
    width: 100%;
  }

  #application_ready_outer .el-select {
    width: 100%;
  }

  #application_ready_outer .input-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
  }

  #application_ready_outer .input-row:last-child {
    margin-bottom: 0;
  }

  #application_ready_outer .input-row > .column:first-child {
    width: 30%;
    text-align: right;
    padding-right: 15px;
  }

  #application_ready_outer .input-row > .column:not(:first-child) {
    width: 70%;
  }



  #application_ready_outer .input-right-button-able {
    background-color: #fc1a34;
    color: white;
  }

  #application_ready_outer .input-right-button-disable {
    background-color: lightgrey;
    color: white;
  }


  .app-item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    max-width: 900px;
    width: 100%;
  }

  #application_ready_outer /deep/ .el-input__inner:focus {
    border: solid 1px #fc1a34;
  }


  #application_ready_outer /deep/ .is-checked .el-radio__inner {
    background-color: #fc1a34;
    border: solid 1px #fc1a34;
  }

  #application_ready_outer /deep/ .is-checked .el-radio__label {
    color: #fc1a34;
  }

  #application_ready_outer /deep/ .el-radio__inner:hover {
    border: solid 1px #fc1a34;
  }


  .avatar-uploader {
    width: 150px;
    height: 150px;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .avatar-uploader img {
    width: 100%;
    height: auto;
    margin: auto;
  }

  .avatar-uploader i {
    color: #eee;
    font-size: 3rem;
    /*width: 100%;*/
    /*height: 100%;*/
  }


  .avatar-uploader .el-icon-camera {
    width: 150px;
    height: 150px;
    line-height: 150px;
    vertical-align: middle;
  }

  .avatar-uploader /deep/ input[type='file'] {
    display: none;

  }

  .upload-files {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .upload-files /deep/ input[type='file'] {
    display: none;

  }

  .code-button {
    margin-left: 15px;
    font-size: 1rem;

    width: 100px;
  }

  .bottom-notice-check {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }

  .bottom-notice-check /deep/ .el-checkbox__label {
    white-space: pre-wrap;
  }


  #application_ready_outer .bottom-notice-check /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #fc1a34;
    border-color: #fc1a34;
  }

  #application_ready_outer .bottom-notice-check /deep/ .el-checkbox__inner:hover {
    border-color: #fc1a34;
  }
  #application_ready_outer .bottom-notice-check /deep/ .el-checkbox__input .el-checkbox__inner {
    border-color: #dcdfe6;
  }

  #application_ready_outer .bottom-notice-check /deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #fc1a34;
  }

  #application_ready_outer .avatar-uploader /deep/ .el-upload--picture-card:hover {
    border-color: #fc1a34;
  }

  #application_letter > div:first-child {
    color: #999;
  }

  #application_letter > div:first-child a {
    /*text-decoration: none;*/
    color: #fc1a34;
  }


  #application_letter .el-button {
    background-color: #fc1a34;
    border-color: #fc1a34;
    width: 30vw;
    max-width: 300px;
    min-width: 150px;
  }

  #application_cards_upload /deep/ .el-upload-list__item {
    max-width: 55vw;
  }

  #application_cards_upload /deep/ .el-upload-list__item-name:hover {
    color: #fc1a34;
  }

  #application_cards_upload .el-button--primary {
    background-color: #fc1a34;
  }

  #official_cards_upload {
    justify-content: space-around;
    text-align: justify;
  }

  #official_cards_upload /deep/ input {
    display: none;
  }

  #official_cards_upload /deep/ .el-upload-list--picture-card .el-upload-list__item-status-label {
    background-color: #fc1a34;
  }

  #official_cards_upload /deep/ .el-upload--picture-card:hover {
    border-color: #fc1a34;
  }



</style>



// WEBPACK FOOTER //
// src/components/group/groupApplicationVues/GroupApplicationReady.vue